module.exports = __webpack_public_path__ + "img/flexible_white.e69cc530.svg";